import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ComponentSelectionStorageService {

  constructor() { }

  public saveWidgetSelection(selectionKey: string, widgetIdentifier: string, value: any) {
    localStorage.setItem(selectionKey + '_' + widgetIdentifier, JSON.stringify(value));
  }

  getWidgetSelection(selectionKey: string, widgetIdentifier: string): any {
    return this.get(selectionKey + '_' + widgetIdentifier);
  }

  save(key: string, value: any) {
    localStorage.setItem(key, JSON.stringify(value));
  }

  get(key: string): any {
    const val = localStorage.getItem(key);
    if (val) {
      try {
        return JSON.parse(val);
      } catch (e) {
        console.log('Could not parse as Json. Key: [' + key + '], value as string: [' + val + ']');
      }
    }
    return null;
  }

  saveToSession(key: string, value: any) {
    sessionStorage.setItem(key, JSON.stringify(value));
  }

  getFromSession(key: string): any {
    const val = sessionStorage.getItem(key);
    if (val) {
      try {
        return JSON.parse(val);
      } catch (e) {
        console.log('Could not parse as Json. Key: [' + key + '], value as string: [' + val + ']');
      }
    }
    return null;
  }

}
